import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  scripts: [],
  currentScript: null,
  loadingScript: false,
  scriptError: null,
  deletingScript: false,
  lastFetched: null,
};

const scriptsSlice = createSlice({
  name: 'scripts',
  initialState,
  reducers: {
    fetchScriptsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchScriptsSuccess: (state, action) => {
      state.loading = false;
      state.error = null;
      state.scripts = action.payload || [];
      state.lastFetched = Date.now();
    },
    fetchScriptsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.scripts = [];
    },
    clearScripts: (state) => {
      state.loading = false;
      state.error = null;
      state.scripts = [];
      state.lastFetched = null;
    },
    fetchScriptStart: (state) => {
      state.loadingScript = true;
      state.scriptError = null;
    },
    fetchScriptSuccess: (state, action) => {
      state.loadingScript = false;
      state.scriptError = null;
      state.currentScript = action.payload;
      // Also update the script in scripts array if it exists
      const scriptIndex = state.scripts.findIndex(
        s => (s._id || s.id) === (action.payload._id || action.payload.id)
      );
      if (scriptIndex !== -1) {
        state.scripts[scriptIndex] = action.payload;
      }
    },
    fetchScriptFailure: (state, action) => {
      state.loadingScript = false;
      state.scriptError = action.payload;
      state.currentScript = null;
    },
    updateScriptShareStatus: (state, action) => {
      const { scriptId, isShared } = action.payload;
      // Update currentScript if it matches
      if (state.currentScript && (state.currentScript._id === scriptId || state.currentScript.id === scriptId)) {
        state.currentScript.isShared = isShared;
      }
      // Update script in scripts array if it exists
      const scriptIndex = state.scripts.findIndex(
        s => (s._id || s.id) === scriptId
      );
      if (scriptIndex !== -1) {
        state.scripts[scriptIndex].isShared = isShared;
      }
    },
    deleteScriptStart: (state) => {
      state.deletingScript = true;
    },
    deleteScriptSuccess: (state, action) => {
      const scriptId = action.payload;
      state.deletingScript = false;
      state.scripts = state.scripts.filter(
        s => (s._id || s.id) !== scriptId
      );
      if (state.currentScript && (state.currentScript._id === scriptId || state.currentScript.id === scriptId)) {
        state.currentScript = null;
      }
    },
    deleteScriptFailure: (state) => {
      state.deletingScript = false;
    },
  },
});

export const {
  fetchScriptsStart,
  fetchScriptsSuccess,
  fetchScriptsFailure,
  clearScripts,
  fetchScriptStart,
  fetchScriptSuccess,
  fetchScriptFailure,
  updateScriptShareStatus,
  deleteScriptStart,
  deleteScriptSuccess,
  deleteScriptFailure,
} = scriptsSlice.actions;

export default scriptsSlice.reducer;

